__webpack_require__.p = "/kc-admin/";